import React from "react";
import { Link } from "react-router-dom";

const HomeTopButtonGroup = () => {
    return ( 
        <div className="col-lg-3 col-6 sbtnui">
           <Link to="/NewPayment/SubmitPayment" > <button type="button" className="btn btn-primary btn-block"><i className="fa fa-plus"></i> Add Payment Balance</button>       </Link>                    
           <Link to="/NewOrder" >  <button type="button" className="btn btn-success btn-block"><i className="fa fa-plus"></i> New Order</button>        </Link>                    
            {/* <button type="button" className="btn btn-warning btn-block" data-toggle="modal" data-target="#QRScanModal"><i className="fa fa-qrcode"></i> Scan QR Code </button> */}
        </div>  
    )
}

export default HomeTopButtonGroup;